import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import {
	OfferEntryJson,
} from '@layouts/Pages/PageOfferEntry';

export interface OffersEntryJsonStore {
	[offerId: number]: {
		data: OfferEntryJson | null;
		isError: boolean;
		isLoading: boolean;
	};
}

const initialState: OffersEntryJsonStore = {};

export const offersEntrySlice = createSlice({
	initialState,
	name: 'offers_entry',
	reducers: {
		clearOfferEntry: (state, action: PayloadAction<number>) => {
			const offerId = action.payload;
			delete state[offerId];
		},
		setOfferEntry: (state, action: PayloadAction<{
			data: OfferEntryJson;
			offerId: number;
		}>) => {
			const {
				data,
				offerId,
			} = action.payload;
			state[offerId] = {
				data,
				isError: false,
				isLoading: false,
			};
		},
		setOfferEntryError: (state, action: PayloadAction<{
			isError: boolean;
			offerId: number;
		}>) => {
			const {
				isError,
				offerId,
			} = action.payload;
			if (!state[offerId]) {
				state[offerId] = {
					data: null,
					isError: false,
					isLoading: false,
				};
			}
			state[offerId].isError = isError;
		},
		setOfferEntryLoading: (state, action: PayloadAction<{
			isLoading: boolean;
			offerId: number;
		}>) => {
			const {
				isLoading,
				offerId,
			} = action.payload;
			if (!state[offerId]) {
				state[offerId] = {
					data: null,
					isError: false,
					isLoading: false,
				};
			}
			state[offerId].isLoading = isLoading;
		},
	},
});

export const {
	clearOfferEntry,
	setOfferEntry,
	setOfferEntryError,
	setOfferEntryLoading,
} = offersEntrySlice.actions;

export const offersEntryReducer = offersEntrySlice.reducer;
